/**
 * Showcase Theme - Main JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  initHeader();
  initColorShowcase();
  initVideoSections();
  initSmoothScroll();
});

/**
 * Header scroll behavior
 */
function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;
  
  let lastScroll = 0;
  
  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll > 50) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
    
    lastScroll = currentScroll;
  }, { passive: true });
}

/**
 * Color showcase functionality
 */
function initColorShowcase() {
  const colorShowcases = document.querySelectorAll('[data-color-showcase]');
  
  colorShowcases.forEach(showcase => {
    const options = showcase.querySelectorAll('.color-option');
    const images = showcase.querySelectorAll('[data-color-image]');
    const nameDisplay = showcase.querySelector('.color-showcase__name');
    
    options.forEach(option => {
      option.addEventListener('click', function() {
        const color = this.dataset.color;
        const colorName = this.dataset.colorName;
        
        // Update active state
        options.forEach(opt => opt.classList.remove('active'));
        this.classList.add('active');
        
        // Update image
        images.forEach(img => {
          img.style.display = img.dataset.colorImage === color ? 'block' : 'none';
        });
        
        // Update name
        if (nameDisplay && colorName) {
          nameDisplay.textContent = colorName;
        }
      });
    });
  });
}

/**
 * Video section play functionality
 */
function initVideoSections() {
  const videoSections = document.querySelectorAll('.video-section');

  function getEmbedUrl(url) {
    if (!url) return null;

    // YouTube
    const ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (ytMatch) {
      return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&rel=0&playsinline=1`;
    }

    // Vimeo
    const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vimeoMatch) {
      return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
    }

    return null;
  }

  videoSections.forEach(section => {
    if (section.dataset.videoInit === 'true') return;
    section.dataset.videoInit = 'true';

    section.addEventListener('click', function() {
      if (this.classList.contains('is-playing')) return;

      const videoUrl = this.dataset.videoUrl;
      const embedUrl = getEmbedUrl(videoUrl);

      if (embedUrl) {
        const iframe = document.createElement('iframe');
        iframe.className = 'video-section__iframe';
        iframe.src = embedUrl;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        this.appendChild(iframe);
        this.classList.add('is-playing');
      } else if (videoUrl) {
        // Direct video file
        const video = document.createElement('video');
        video.className = 'video-section__iframe';
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        this.appendChild(video);
        this.classList.add('is-playing');
      }
    });
  });
}

/**
 * Smooth scroll for anchor links
 */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

/**
 * Utility: Debounce function
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * Utility: Throttle function
 */
function throttle(func, limit) {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
